import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
import { DrawerMain } from './DrawerMain';
import { DrawerColorVariant } from './Drawer';
export var DrawerContent = function DrawerContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      panelContent = _a.panelContent,
      _a$colorVariant = _a.colorVariant,
      colorVariant = _a$colorVariant === void 0 ? DrawerColorVariant.default : _a$colorVariant,
      props = __rest(_a, ["className", "children", "panelContent", "colorVariant"]);

  return React.createElement(DrawerMain, null, React.createElement("div", Object.assign({
    className: css(styles.drawerContent, colorVariant === DrawerColorVariant.light200 && styles.modifiers.light_200, className)
  }, props), children), panelContent);
};
DrawerContent.displayName = 'DrawerContent';